'use strict';

(function(z, Backbone, Translator){

    var TransferMaterialImportModel = Backbone.Model.extend({

        /**
         * URL către ruta Symfony
         */
        url: function() {
            return '/materialtransfer/import';
        },

        /**
         * Validare model
         */
        validation: {
            'file': {
                fn: function(val, attr, computed) {

                    if (computed.isTemplateEmpty) {
                        return Translator.trans('js.error_message_importform_template_required');
                    }

                    if (computed.isTemplateInvalidType) {
                        return Translator.trans('js.error_message_importform_template_invalidtype');
                    }

                    if (computed.isTemplateInvalidSize) {
                        return Translator.trans('js.error_message_importform_template_invalidsize');
                    }
                }
            }
        }

    });

    z.TransferMaterialImportModel = TransferMaterialImportModel;

})(window.z = window.z || {}, Backbone, Translator);
